import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  approveGoal,
  getAllGoals,
  getGoalStatusesForFilterTabs,
} from "../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const Approval = ({ selectedGoals, props, meta, setSelectedGoals }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.appraisal);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = React.useState("");
  const handleApprove = () => {
    const lastExtendIds = selectedGoals.map((goal) => goal.last_extend_id);
    const ids = { ids: lastExtendIds, status: status };
    if (!status) {
      return enqueueSnackbar("Please select a status...!", {
        variant: "error",
      });
    }
    dispatch(approveGoal(ids)).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        const data = { ...props, ...meta };
        dispatch(getAllGoals(data));
        dispatch(getGoalStatusesForFilterTabs(props));
        setOpen(false);
        setSelectedGoals([]);
      }
    });
  };

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  return (
    <GlobalDialog
      title="Approve/Reject Goals"
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      popupButton={
        <Button
          variant="outlined"
          startIcon={<Icon icon="mdi:approve" width="16" height="16" />}
          sx={{ borderRadius: 4 }}
          size="small"
          color="success"
          onClick={() => setOpen(true)}
        >
          Approve
        </Button>
      }
      content={
        <>
          <Box>
            <Box pt={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  onChange={handleChange}
                >
                  <MenuItem value={2}>Approve</MenuItem>
                  <MenuItem value={3}>Reject</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
              <Stack direction={"row"} spacing={1}>
                <CancelButton size={"small"} action={() => setOpen(false)}>
                  Cancel
                </CancelButton>
                <UpdateButton
                  disabled={loading}
                  action={handleApprove}
                  size={"small"}
                >
                  {loading ? "Please Wait..." : "Update Status"}
                </UpdateButton>
              </Stack>
            </Box>
          </Box>
        </>
      }
    />
  );
};

export default Approval;
